module.exports = __webpack_public_path__ + "static/6305-woodrose-40-31a7f633953452e603c9d1e900fef491.jpg";